/**
 * 本体カラー（第1オプション）変更時に、現在の他オプション選択値との組み合わせが
 * 存在しないバリアントになる場合、新しい本体カラーで利用可能な最初のバリアントへ
 * 他オプションを自動フォールバックする。
 *
 * 背景:
 *   Shopify Bundles 等で組み合わせを絞っている商品では、本体カラー変更時に無効な
 *   組み合わせになると variant_id が更新されず画像も正しく切り替わらない。テーマ側の
 *   variant-picker には自動調整ロジックが無いため、本スクリプトで補う。
 *
 * 動作条件:
 *   全オプション組み合わせ数より variant 数が少ない商品でのみ発火（全組み合わせ存在する
 *   通常商品では何もしない）。product-information.liquid から該当商品のみに配信される。
 */
(function () {
  let variantsCache = null;

  function init() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return;

    const productUrl = (picker.dataset.productUrl || '').split('?')[0];
    if (!productUrl) return;

    fetch(`${productUrl}.js`)
      .then((r) => (r.ok ? r.json() : null))
      .then((product) => {
        if (!product || !Array.isArray(product.variants)) return;
        const fullCombo = (product.options || []).reduce(
          (acc, o) => acc * (o.values ? o.values.length : 1),
          1
        );
        if (product.variants.length >= fullCombo) return;
        variantsCache = product.variants;
        picker.addEventListener('change', handleChange, true);
      })
      .catch(() => {});
  }

  function handleChange(event) {
    if (!variantsCache) return;
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const picker = input.closest('variant-picker');
    if (!picker) return;

    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    if (fieldsets.length < 2) return;
    if (!fieldsets[0].contains(input)) return;

    const newBody = input.value;
    const others = fieldsets.slice(1);
    const otherValues = others.map(
      (fs) => fs.querySelector('input:checked')?.value ?? null
    );

    const matches = (v) =>
      v.available &&
      v.options[0] === newBody &&
      others.every((_, i) => v.options[i + 1] === otherValues[i]);

    if (variantsCache.some(matches)) return;

    const fallback = variantsCache.find(
      (v) => v.available && v.options[0] === newBody
    );
    if (!fallback) return;

    others.forEach((fs, i) => {
      const value = fallback.options[i + 1];
      const radio = fs.querySelector(
        `input[type="radio"][value="${CSS.escape(value)}"]`
      );
      if (radio && !radio.checked) radio.checked = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
